import axios from "axios";
export default {
  getClients: function(token, searchText) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}clients/${searchText}`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getProjectDetails: function(token, id) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}projects/${id}`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getRateCardDetails: function(token, id) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}${id}/ratecard`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
